import { visitLineItems } from '@markku/db'
import { createInsertSchema, createSelectSchema } from 'drizzle-zod'
import { z } from 'zod'
import { selectProductSchema } from './product'

export const selectVisitLineItemSchema = createSelectSchema(visitLineItems, {
  internalPurchasePriceVat0: z.string().nullable().optional(),
})

export const insertVisitLineItemSchema = createInsertSchema(
  visitLineItems,
).omit({
  id: true,
  createdAt: true,
  updatedAt: true,
  deletedAt: true,
  invoiceId: true,
  billedAt: true,
  billedByUserId: true,
  paidAt: true,
})

export const selectVisitLineItemWithProductSchema =
  selectVisitLineItemSchema.extend({
    product: selectProductSchema.nullable().optional(),
    billedByUser: z
      .object({
        id: z.number(),
        firstName: z.string(),
        lastName: z.string(),
      })
      .nullable()
      .optional(),
  })

export const updateVisitLineItemSchema = insertVisitLineItemSchema.partial()

export type VisitLineItem = z.infer<typeof selectVisitLineItemSchema>
export type VisitLineItemWithProduct = z.infer<
  typeof selectVisitLineItemWithProductSchema
>
export type CreateVisitLineItem = z.infer<typeof insertVisitLineItemSchema>
export type UpdateVisitLineItem = z.infer<typeof updateVisitLineItemSchema>
